import OtpBoxes from './OtpBoxes';
export default OtpBoxes;
